import { useCallback, useState } from 'react';
import {
  getStoredTimezoneMode,
  setStoredTimezoneMode,
  type TimezoneMode,
} from '@/utils/timezone';

export default function useTimezoneModel() {
  const [mode, setModeState] = useState<TimezoneMode>(() =>
    getStoredTimezoneMode(),
  );

  const setMode = useCallback((nextMode: TimezoneMode) => {
    setStoredTimezoneMode(nextMode);
    setModeState(nextMode);
  }, []);

  return {
    mode,
    setMode,
  };
}
